import { render, staticRenderFns } from "./CpdPoints.vue?vue&type=template&id=d2349784&scoped=true"
import script from "./CpdPoints.vue?vue&type=script&lang=js"
export * from "./CpdPoints.vue?vue&type=script&lang=js"
import style0 from "./CpdPoints.vue?vue&type=style&index=0&id=d2349784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2349784",
  null
  
)

export default component.exports